<template>
  <div>
    <v-app-bar
      color="systemwhite"
      clipped-left
      app
      elevate-on-scroll
      fade-img-on-scroll
    >
      <v-app-bar-nav-icon
        color="primary"
        @click="menudrawer = !menudrawer"
      ></v-app-bar-nav-icon>
      <a href="/" class="col-auto col-sm-auto">
        <v-img
          class="mx-auto"
          max-width="165"
          width="165"
          max-height="30"
          src="../assets/kyano-cards-logo-dark.svg"
        ></v-img>
      </a>
      <v-breadcrumbs :items="this.breadcrumbs" class="d-none d-sm-flex">
        <v-breadcrumbs-item
          slot="item"
          slot-scope="{ item }"
          exact
          :to="item.href"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
      <v-spacer></v-spacer>
      <Topmenuapps />
      <!--if ingelogd-->
      <Topmenuprofile />
      <!--endif-->
    </v-app-bar>
    <v-navigation-drawer clipped v-model="menudrawer" app>
      <span class="d-flex d-sm-none pa-2 my-auto">
       <v-app-bar-nav-icon
       class="my-auto"
        color="primary"
        @click="menudrawer = !menudrawer"
      ></v-app-bar-nav-icon>
      <a href="/" class="col-auto col-sm-auto">
        <v-img
          class="mx-auto"
          max-width="165"
          width="165"
          max-height="30"
          src="../assets/kyano-cards-logo-dark.svg"
        ></v-img>
      </a>
      </span>
      <v-list shaped>
        <v-list-item-group color="#34c759">
          <v-list-item
            v-for="item in sidebar"
            :key="item.title"
            link
            :to="item.to"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider></v-divider>
      <v-list shaped>
        <v-list-item-group color="#34c759">
          <v-list-item
            v-for="item in sidebar2"
            :key="item.title"
            link
            :to="item.to"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <span class="kyano-ui-bottom-nav">
      <v-bottom-navigation fixed grow min-height="75px">
        <v-btn
          v-for="item in bottomnav"
          :key="item.title"
          link
          color="primary accent-4"
          text
          :to="item.to"
        >
          <span>{{ item.title }}</span>
          <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </span>
  </div>
</template>
<script>
import Topmenuapps from "./Topmenuapps.vue";
import Topmenuprofile from "./Topmenuprofile.vue";

export default {
  components: { Topmenuprofile, Topmenuapps },
  props: {
    breadcrumbs: Array,
  },
  data: () => ({
    menudrawer: null,
    sidebar: [
      {
        title: "Cards",
        icon: "fal fa-credit-card-blank",
        to: "/cards",
      },
      {
        title: "Profielen",
        icon: "fal fa-user-friends",
        to: "/profiles",
      },
      {
        title: "Bedrijven",
        icon: "fal fa-building",
        to: "/companies",
      },
    ],
    sidebar2: [
      {
        title: "Instellingen",
        icon: "fal fa-cog",
        to: "/settings",
      },
      {
        title: "Support",
        icon: "fal fa-question-circle",
        to: "/support",
      },
    ],
    bottomnav: [
      {
        title: "Cards",
        icon: "fal fa-credit-card-blank",
        to: "/cards",
      },
      {
        title: "Profielen",
        icon: "fal fa-user-friends",
        to: "/profiles",
      },
      {
        title: "Bedrijven",
        icon: "fal fa-building",
        to: "/companies",
      },
      {
        title: "Instellingen",
        icon: "fal fa-cog",
        to: "/settings",
      },
    ],
  }),
};
</script>

<style>
@media(min-width:992px){
  .kyano-ui-bottom-nav{
    display: none;
  }
}
.kyano-ui-bottom-nav .v-btn__content span{
    font-size: 12px;
    margin-top: 5px;
}
.v-navigation-drawer .v-icon {
  width: 25px;
}

.v-toolbar__content .v-breadcrumbs__item {
  font-size: 18px;
  font-weight: inherit;
  color: #011a62;
}

.v-toolbar__content .v-breadcrumbs__item.v-breadcrumbs__item--disabled {
  font-size: 22px !important;
  font-weight: bold !important;
  color: #011a62 !important;
}
</style>
